import axios from '@/utils/request'
var Qs = require('qs')

export default {
	// 2021-01-03
	search(params) {
		return axios.get('/mms/suppliers', params)
	},
	// 2021-01-03
	findByTenantId() {
		return axios.get('/mms/suppliers/find-by-tenant-id')
	},
	// 2021-01-03
	create(params) {
		return axios.post('/mms/suppliers', params)
	},
	// 2021-01-03
	update(id, params) {
		return axios.put('/mms/suppliers/' + id, params)
	},
	// 2021-01-03
	delete(id) {
		return axios.delete('/mms/suppliers/' + id)
	},
	// 2021-01-12
	findById(id) {
		return axios.get('/mms/suppliers/' + id)
	}




}

